import { render, staticRenderFns } from "./attributes-query-ranking-modal.vue?vue&type=template&id=2a82d29e&scoped=true"
import script from "./attributes-query-ranking-modal.vue?vue&type=script&lang=ts"
export * from "./attributes-query-ranking-modal.vue?vue&type=script&lang=ts"
import style0 from "./attributes-query-ranking-modal.vue?vue&type=style&index=0&id=2a82d29e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82d29e",
  null
  
)

export default component.exports